import { FC, useEffect, useState } from "react"
import { Footer } from "../../../components/Footer/footer"
import { ChrevonLeftIcon } from "../../../components/MenuIcons/ChevrotLeft"
import { useNavigate } from "react-router-dom";
import myOrderImg from '../../../assets/images/myOrder.svg'
import './index.css'
import { OrderItem } from "../../../components/OrderItem/OrderItem";
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { cpfMask, datetimeToDateBR } from "../../../functions/mask";
import { centsToFloat } from "../../../functions/price_functions";
import { AdditionalType, ItemFractionalType } from "../../../contexts/OrderContext";
import useAuth from "../../../hooks/useAuth";
import Loading from "react-loading";
import ReactLoading from "react-loading";



type ProductOrderType = {
    id: number;
    name: string;
    quantity: number;
    unitPrice: number;
    promotionalPrice: number;
    variation: string;
    fractions: ItemFractionalType[];
    additionals: AdditionalType[];
};

export type OrderFindedType = {
    id: number;
    ext: string;
    date: string;
    observation: string;
    type: string;
    status: Array<StatusResponseType>;
    allStatus: Array<StatusResponseType>;
    store: string;
    address: string;
    user: any;
    products: ProductOrderType[];
    totalValue: number;
    freight: number;
    statusId: number;
    content: any;
};

type StatusResponseType = {
    id: number;
    name: string;
    slug: string;
    order: number;
    displayStatusWebapp: boolean;
    colorSetting?: {
        background?: string
    };
};

type ProductResponseType = {
    id: number;
    code: string;
    content: any;
    sku: string;
    price: number;
    quantity: number;
    discount: number;
};

type PluginspaceResponseType = {
    name: string;
};

export type OrderResponseType = {
    id: number;
    classifierId: number | null;
    content: any;
    statusId: number;
    created: string;
    customerId: string;
    deliveryTax: number;
    discountGeral: number;
    locationId: number;
    orderidExt: string;
    pluginconfigId: number;
    pluginspaceId: number;
    products: Array<ProductResponseType>;
    status: Array<StatusResponseType>;
    type: string;
    pluginspace: PluginspaceResponseType;
    observation: string;
};

const CustomerOrder: FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const { getToken, registerAccess } = usePluginspace();
    const { loginInfo, getInitialData } = useAuth()

    const [findedOrders, setFindedOrders] = useState<Array<OrderFindedType>>(
        []
    )


    const getMyOrders = async () => {
        setLoading(true);
        await api
            .post(
                `/api/orders/filter`,
                {
                    cpf: loginInfo.identifier,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then((response) => {
                const orderResponse = response.data;

                const newOrders = orderResponse.data.map(
                    (order: OrderResponseType) => {
                        let orderAddress = null;
                        if (order.content && order.content.orderAddress) {
                            orderAddress = order.content.orderAddress;
                        }
                        let totalValue = 0;
                        order.products.map((product) => {
                            totalValue += product.price * product.quantity;
                        });
                        return {
                            id: order.id,
                            ext: order.orderidExt,
                            date: datetimeToDateBR(order.created),
                            type: order.type,
                            statusId: order.statusId,
                            status: order.status.sort((a, b) => a.order - b.order),
                            store: order.pluginspace.name,
                            observation: order.observation,
                            address: orderAddress ? `${orderAddress.address} - ${orderAddress.district
                                } - ${orderAddress.city} - ${orderAddress.cep ? orderAddress.cep : ""
                                }` : '',
                            user: {
                                name: (order.content && order.content.customer) ? order.content.customer : '',
                                cpf: (order.content && order.content.customerCpf) ? cpfMask(order.content.customerCpf) : '',
                            },
                            products: order.products.map((product) => ({
                                id: product.id,
                                name: product.content.productName,
                                quantity: product.quantity,
                                unitPrice: centsToFloat(
                                    product.price + product.content.discount
                                ),
                                promotionalPrice: centsToFloat(
                                    product.price
                                ),
                                fractions: product.content && product.content.fractionated ? product.content.fractionated : [],
                                additionals: product.content && product.content.additionals ? product.content.additionals : [],
                                variation: product.content.variation
                                    ? JSON.parse(product.content.variation)
                                    : {},
                            })),
                            totalValue: centsToFloat(totalValue),
                            freight: (order.content && order.content.deliveryFee)
                                ? centsToFloat(order.content.deliveryFee)
                                : 0,
                            content: order.content
                        };
                    }
                );

                setFindedOrders(newOrders);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                return null;
            });

    }
    useEffect(() => {
        getMyOrders()
    }, [])

    return (
        <div className="mainPageOrder">
            {loading ? (
                <>
                    <ReactLoading
                        type={"spin"}
                        color={"#b5b5b5"}
                        height={20}
                    />
                </>
            ) : (
                <div className="contentMyOrders">
                    <div className="imagemMyOrder">
                        <img src={myOrderImg} />
                    </div>
                    <div className="headerMyOrder">
                        <h4>Meus Pedidos</h4>
                    </div>

                    <div className="ordernacaoMyOrder">
                        <span>Ordernar por</span>
                        {/*Select */}
                    </div>


                    {/*todos os pedidos, ocupando toda a tela com overflow */}
                    <div className="myOrders">
                        {findedOrders.map((order, index) => (
                            <OrderItem order={order} />
                        ))

                        }
                    </div>

                </div>
            )

            }
        </div>
    )
}

export { CustomerOrder }